import {
    TariffDetailApiV1TariffTariffUuidGetParams,
    TariffDTO,
    TariffListApiV1TariffGetParams,
    TariffListOutputDTO,
    UserTariffActiveApiV1UserTariffGetParams,
    UserTariffDTO,
} from '../swagger/dto'
import { getRequest, postRequest } from './config'
import { TARIFF_URL, USER_TARIFF_URL } from './endpoints.constants'

export const getTariffList = async (params: TariffListApiV1TariffGetParams) => {
    const response = await getRequest<TariffListOutputDTO>(TARIFF_URL, params)
    return response.data
}

export const getTariffByUuid = async (params: TariffDetailApiV1TariffTariffUuidGetParams) => {
    const response = await getRequest<TariffDTO>(`${TARIFF_URL}/${params.tariffUuid}`)
    return response.data
}

export const getUserTariff = async () => {
    const response = await getRequest<UserTariffDTO>(USER_TARIFF_URL)
    return response.data
}

export const activateUserTariff = async (
    payload: UserTariffActiveApiV1UserTariffGetParams,
): Promise<UserTariffDTO> => {
    const response = await postRequest<UserTariffActiveApiV1UserTariffGetParams, UserTariffDTO>(`${USER_TARIFF_URL}/activate`, payload)

    return response.data
}
